import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import bg_img from '../assets/images/landing_bg.png';
import '@fontsource/league-spartan';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import ExploreIcon from '@mui/icons-material/Explore'; 
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AssistantIcon from '@mui/icons-material/Assistant';
import bgVideo from '../assets/videos/bg_vid.mp4';
import { useMediaQuery } from '@mui/system';

const Landing = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100vh',
  overflow: 'hidden', // To ensure the video doesn't overflow
});

const BackgroundVideo = styled('video')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover', // Ensures the video covers the entire background
  zIndex: -100, // To place the video behind other elements
});

const MidBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  left: 0,
  right: 0,
    backgroundColor: 'rgba(51, 145, 173, .9)', // Blue color with 70% opacity
  width:'100%',
  display: 'flex',
  fontsize: '2rem',
  height: '100px',
  justifyContent: 'space-between',
  alignItems: 'center',
}));



const Title = styled(Typography)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(55),
    left: theme.spacing(1), // Align to the right
    color: 'white',
    fontFamily: 'League Spartan', // Apply League Spartan font
    fontWeight: 'bold',
    fontSize: '2rem', // Make the text much bigger
    textAlign: 'left', // Right-align the text
    wordWrap: 'break-word', // Enable text wrapping
    maxWidth: '90%', // Optional: Limit the width to help with wrapping
  }));


const HomePageMobile: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const [accessToken, setAccessToken] = React.useState<string | null>(sessionStorage.getItem('accessToken'));
  const navigate = useNavigate();
  const isphone = useMediaQuery('(max-width:800px)');
  const version = process.env.REACT_APP_VERSION
  const goToLogin = () => {
    //debugger;
      navigate('../app/landing-check'); 
  };

  // polling for access token in case page navigates before token is recieved from auth0
  useEffect(() => {
    const interval = setInterval(() => {
      const token = sessionStorage.getItem('accessToken');
      if (token) {
        setAccessToken(token);
        clearInterval(interval);
      }
    }, 100); // Check every 100ms

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  useEffect(() => {
    //console.log(`isAuthenticated: ${isAuthenticated}, isLoading: ${isLoading}, accessToken: ${accessToken}`);
    if (isAuthenticated && !isLoading && accessToken) {
      //debugger;
    goToLogin();
    }
  }, [isAuthenticated, isLoading, accessToken]);

  return (
    <Box>
        <Button
          variant="contained"
          sx={{
            position: 'absolute',
            top: '620px',
            right: 'calc(50% - 100px)',
            backgroundColor: '#FFDD57', // Yellow button color
            color: 'black', // Black text color
            fontWeight: 'bold',
            fontSize: '1.2rem', // Make the text bigger
            padding: '12px 24px', // Make the button bigger
            width: '200px',
            marginRight: '20px', // Add margin to the right
            '&:hover': {
              backgroundColor: '#FFC107', // Slightly darker yellow on hover
            },
          }}
          onClick={goToLogin}
        >
          Get Started
        </Button>
      <Title>
      Your AI Guide to colleges and careers in Washington State
      </Title>
      <MidBar>
        <Box display={'flex'} flexDirection={'column'} width='100%' sx={{justifyContent: 'space-between', margin: '50px'}}>
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
            <ExploreIcon sx={{fontSize: '30px', marginBottom: '0px', color: '#fff', marginRight: '10px'}} />
          <Typography variant='h3'sx={{fontSize: '1rem'}}>Choose Your Path</Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <VolunteerActivismIcon sx={{fontSize: '30px', marginBottom: '0px', color: '#fff', marginRight: '10px'}} />
          <Typography variant='h3' sx={{fontSize: '1rem'}}>Get the Help You Need</Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <AssistantIcon sx={{fontSize: '30px', marginBottom: '0px', color: '#fff', marginRight: '10px'}} />
          <Typography variant='h3' sx={{fontSize: '1rem'}}>Chat With Your Guide</Typography>
          </Box>
        </Box>
      </MidBar>
      <Typography variant='body1' textAlign={'left'} sx={{position: 'absolute', bottom: '10px', left: '10px'}}>
        Powered by Campus Evolve &nbsp; {version}
      </Typography>
      </Box>
  );
};

export default HomePageMobile;